// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueCookies from 'vue-cookies'
import ajax from "./assets/ajax";
import mixin from "./assets/utils/mixin";
import '@/assets/csui/css/csui.css';
import '@/assets/css/global.css';
import '@/assets/css/ui_inquiry.css';
import '@/assets/css/page.css';
import installReClick from '@/assets/csui/directive/preventReClick'
import installAlert from "@/components/alert";
import installToast from "@/assets/csui/components/toast";
import installLoading from "@/assets/csui/components/loading"
import 'core-js/es6/promise'
import routerToClear from "./assets/utils/session-conf";
import StorageConst from "./assets/utils/StorageConst"

Vue.config.productionTip = false

Vue.prototype.$ajax = ajax;

Vue.mixin(mixin);
Vue.use(VueCookies);
Vue.use(installAlert);
Vue.use(installToast);
Vue.use(installLoading);
Vue.use(installReClick);
import RecordNumber from "@/components/RecordNumber/RecordNumber";
Vue.component("RecordNumber", RecordNumber);
// 根据路由设置标题
router.beforeEach((to, from, next) => {
  /*路由发生改变修改页面的title */
  if(to.meta.title) {
    document.title = to.meta.title
  }
  /*localStorage清空配置*/
  for(const name in routerToClear){
    if(routerToClear.hasOwnProperty(name) && routerToClear[name] === to.name){
      for(let key in StorageConst.LOCAL_PAGE_LIST){
        localStorage.setItem(StorageConst.LOCAL_PAGE_LIST[key], "");
      }
      break;
    }
  }
  next();
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js